export enum PERMISSION_KEYS {
    ACCOUNT_SITE_LIST = 'account-site-list',
    ACCOUNT_SITE_ADD = 'account-site-add',
    ACCOUNT_SITE_EDIT = 'account-site-edit',
    ACCOUNT_SITE_DELETE = 'account-site-delete',

    SITE_SETUP_VIEW = 'site-setup-view',
    SITE_SETUP_EDIT = 'site-setup-edit',
    SITE_SETUP_DELETE = 'site-setup-delete',
    SITE_SETUP_EDIT_DETAILS = 'site-setup-edit-details',

    CIRCUIT_VIEW = 'circuit-view',
    CIRCUIT_EDIT = 'circuit-edit',

    TEAM_SETUP_VIEW = 'team-setup-view',
    TEAM_SETUP_EDIT = 'team-setup-edit',

    PROJECTS_VIEW = 'projects-view',
    PROJECTS_EDIT = 'projects-edit',
    PROJECTS_DELETE = 'projects-delete',
    PROJECTS_ADD = 'projects-add',

    JOBS_VIEW = 'jobs-view',
    JOBS_EDIT = 'jobs-edit',
    JOBS_DELETE = 'jobs-delete',
    JOBS_ADD = 'jobs-add',

    JOB_INSPECTION_VIEW = 'job-inspection-view',
    JOB_INSPECTION_EDIT = 'job-inspection-edit',

    USER_ACCESS_VIEW = 'user-access-view',
    USER_ACCESS_EDIT = 'user-access-edit',

    REPORTS_VIEW = 'reports-view',
    REPORTS_EDIT = 'reports-edit',
    REPORTS_DELETE = 'reports-delete',

    USERS_VIEW = 'users-view',
    USERS_EDIT = 'users-edit',
    USERS_DELETE = 'users-delete',
    USERS_ADD = 'users-add',

    PAYMENT_AND_SUBSCRIPTION_MANAGE = 'payment-and-subscription-manage',
    ADMIN_PORTAL_VIEW = 'admin-portal-view',

    ADMIN_FIELDS_DB_VIEW = 'admin-fields-db-view',
    ADMIN_GAS_DB_VIEW = 'admin-gas-db-view',
    ADMIN_DUST_DB_VIEW = 'admin-dust-db-view',
    ADMIN_WORK_PERMIT_DB_VIEW = 'admin-work-permit-db-view',
    ADMIN_INSPECTION_FORMS_DB_VIEW = 'admin-inspection-forms-db-view',

    ADMIN_ACCOUNT_LIST_VIEW = 'admin-account-list-view',
    ADMIN_ACCOUNT_USERS_VIEW = 'admin-account-users-view',
    ADMIN_WORK_PERMIT_BY_ACCOUNT_VIEW = 'admin-work-permit-by-account-view',

    ADMIN_BILLING_PLAN_LIST_VIEW = 'admin-billing-plan-list-view',
    ADMIN_BILLING_PLAN_EDIT = 'admin-billing-plan-edit',
}
